import { render, staticRenderFns } from "./GlobalSummaryCard.vue?vue&type=template&id=4d1b8242&scoped=true&"
import script from "./GlobalSummaryCard.vue?vue&type=script&lang=js&"
export * from "./GlobalSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSummaryCard.vue?vue&type=style&index=0&id=4d1b8242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1b8242",
  null
  
)

export default component.exports